export const API_URL =
    process.env.NODE_ENV === "production"
        ? "https://api2.taitur.net"
        : "http://localhost:8010/proxy";
